// extracted by mini-css-extract-plugin
export var banner = "_o1-0";
export var settingRow = "_o1-2";
export var titleIcon = "_o1-1";